<template>
  <div class="home">
    <el-carousel
      height="100vh"
      direction="vertical"
      :autoplay="false"
      trigger="click"
      ref="carousel"
      :loop="false"
      :show-indicators="false"
      @mousewheel="rollScroll"
      @change="handleChange"
    >
      <el-carousel-item>
        <BannerView />
      </el-carousel-item>
      <el-carousel-item>
        <DevelopView :InitialIndex="InitialIndex" />
      </el-carousel-item>
      <el-carousel-item>
        <BusView :InitialIndex="InitialIndex" />
      </el-carousel-item>
      <el-carousel-item>
        <HonorView :InitialIndex="InitialIndex" />
      </el-carousel-item>
    </el-carousel>
    <div class="main">
      <BannerView />
      <DevelopMinView />
      <BusMinView/>
      <HonorMinView/>
      <BottomMinView/>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import BannerView from "@/components/home/BannerView.vue";
import DevelopView from "@/components/home/DevelopView.vue";
import HonorView from "@/components/home/HonorView.vue";
import BusView from "@/components/home/BusView.vue";
import DevelopMinView from "@/components/home/DevelopMinView.vue";
import BusMinView from "@/components/home/BusMinView.vue";
import HonorMinView from "@/components/home/HonorMinView.vue";
import BottomMinView from "@/components/BottomMinView.vue";

const carousel = ref("");
let timer = ref(null);
const InitialIndex = ref(0);

const rollScroll = (e) => {
  if (timer.value) {
    clearTimeout(timer.value);
  }
  timer.value = setTimeout(() => {
    if (e.wheelDelta > 0) {
      carousel.value.prev();
    } else {
      carousel.value.next();
    }
  }, 200);
};

const handleChange = (e) => {
  InitialIndex.value = e;
  console.log(e);
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  position: fixed;
  top: 84px;
  left: 0;

  ::v-deep .el-carousel__indicators {
    display: none;
  }
}

@media (max-width: 610px) {
  .home {
    width: 100%;
    position: relative;
    top: 0;

    .el-carousel {
      display: none;
    }
  }
}

.demonstration {
  color: var(--el-text-color-secondary);
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item {
  background-color: white;
}
</style>
